// // quickLinks.ts
// import { category } from './Category';
// import { subCategoryData } from './subCategoryData';

import { category, subCategoryData } from "../app/listings/Category";

type QuickLinkSection = {
  title: string;
  links: { label: string; href: string }[];
};

const toTitleCase = (str: string) =>
  str
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const quickLinks: QuickLinkSection[] = [];

Object.keys(category).forEach((catKey) => {
  const section: QuickLinkSection = {
    title: toTitleCase(catKey),
    links: [
      {
        label: `All ${toTitleCase(catKey)}`,
        href: `/listings/${catKey}`,
      },
    ],
  };

  const subTypes = subCategoryData[catKey];
  if (subTypes) {
    Object.values(subTypes).forEach((subObj) => {
      Object.keys(subObj).forEach((subKey) => {
        section.links.push({
          label: toTitleCase(subKey.replaceAll("-price-in-pakistan","")),
          href: `/listings/${catKey}/${subKey}`,
        });
      });
    });
  }

  quickLinks.push(section);
});
